import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  copyPresentation,
  setPresentationToPublic,
  setPresentationToPrivate,
  fetchMyPresentations,
  deletePresentation
} from '../../../../../../stores/my-presentations/my-presentations.actions'
import { getPresentationFromTheList } from '../../../../../../stores/my-presentations/my-presentations.selectors'

const mapStateToProps = (state, { id }) => {
  const presentation = getPresentationFromTheList(state, id)
  return {
    token: presentation.token,
    isPublic: presentation.public,
    delivered: presentation.lesson && presentation.lesson.delivered
  }
}

const mapDispatchToProps = dispatch => ({
  copy: id => dispatch(copyPresentation(id)).catch(errorHandler),
  setToPublic: id => dispatch(setPresentationToPublic(id)).catch(errorHandler),
  setToPrivate: id =>
    dispatch(setPresentationToPrivate(id)).catch(errorHandler),
  fetchPresentations: params => dispatch(fetchMyPresentations(params)),
  deleteItem: id => dispatch(deletePresentation(id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContextMenu)
